import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import Hero from "./components/hero";
import Qualities from "./components/qualities";
import Navbar from "components/navbar/landingPage-navabar";
import Process from "./components/process";
import ProfessionalTools from "./components/profeesionalTools";
import FAQs from "./components/Faqs";

import Footer from "components/footer";
import Pricing from "./components/pricing";
import Reviews from "./components/reviews";
import GetStarted from "components/getStarted";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <Container>
      <Navbar />
      <Hero />
      <Qualities />
      <Process />
      <ProfessionalTools />
      <Pricing />
      <Reviews />
      <FAQs />
      <GetStarted />
      <Footer />
    </Container>
  );
};

export default Home;

const Container = styled.main`
  /* overflow-x: hidden; */
`;
